import { AppContext } from "@Context/common/general/context";
import MetricFilterTypes from "@Enums/MetricFilterTypes";
import { getPerformanceLabel, getPerformanceShade } from "@Helpers/feedback";
import useI18n from "@i18n";
import { capitalize, Stack, SxProps, Typography, useTheme } from "@mui/material";
import { StandardPalette } from "@Themes/palettes/mui-palette-extension";
import { useContext } from "react";

interface IBybPerformanceChip {
  score: number;
  metricKey?: MetricFilterTypes;
  showAbsoluteValue?: boolean;
  sx?: SxProps;
}

const BybPerformanceChip = ({ score, metricKey, showAbsoluteValue = false, sx = {} }: IBybPerformanceChip) => {
  const { i18n } = useI18n();
  const theme = useTheme();
  const { state } = useContext(AppContext);
  const isVR = state.device.isUnityEmbedded;

  if (!state.user) {
    return null;
  }

  const creationDate = state.user.creationDate ? new Date(state.user.creationDate).getTime() : null;
  const performanceLabel = getPerformanceLabel(metricKey || MetricFilterTypes.BYB_IQ, score, creationDate);
  const performanceShade = getPerformanceShade(metricKey || MetricFilterTypes.BYB_IQ, score, theme, creationDate);
  const performanceColor = isVR ? performanceShade.v200 : (performanceShade as StandardPalette).v400;

  return (
    <Stack spacing={0.5} bgcolor={`${performanceColor}20`} paddingY={0.6} paddingX={1.75} borderRadius={2} width="fit-content" sx={sx}>
      <Typography variant="textBase500" color={performanceColor}>
        {showAbsoluteValue ? `${Math.round(score)}%` : capitalize(i18n(`performance.label.${performanceLabel}`))}
      </Typography>
    </Stack>
  );
};

export default BybPerformanceChip;
